/**
 * @module b-form-widget
 */
define('mrg-form/b-form-field/b-form-field', function (require) {
	'use strict';

	var $ = require('jquery'),
		toolkit = require('toolkit/b-toolkit/b-toolkit');

	var ENTER_CODE = 13;

	return toolkit.create('b-form-field', {
		throttling: 300,

		/**
		 * Признак того, что форма не валидна
		 * @type {String|null} - тип ошибки
		 */
		error: null,
		errorText: null,

		init: function () {
			this._initElements();
		},

		onRender: function () {
			this._initElements();
		},

		_initElements: function () {
			var $field = this.$('__input>[data-bem]');

			var data = this.getData();

			if ($field.length) {
				this._initInput($field);
			} else {
				this.$nativeInput = this._findNativeInput();
			}

			this.name = this.$el.attr('data-field-name');

			if (!this.name) {
				this.name = (this.$nativeInput || this.$el.find('input:checked')).prop('name');
			}

			this.notValidated = this.$el.hasMod('not-validated');
			this.compact = this.$el.hasMod('compact');
			this.hidden = this.$el.hasMod('hidden');

			// элемент для того чтобы понимать для модификатора responsive
			// какие сейчас стили - для мобильной версии или для десктопной
			this.$mediaProp = this.$('.b-form-field__media-phone');

			// валидаторы которые срабатывают на blur
			this.blurValidators = data.blurValidators;

			// если нужно отключает анимация ошибок для некоторых браузеров
			this._offErrorAnimate();

			// кидаем вверх по дому событие для формы,
			// чтобы она например могла переподписаться на события после инициализации филда
			this.$el.trigger('bFormFieldInitEnd', this);
		},

		_initInput: function ($input) {
			this.input = $input.getBlock();

			this.input
				.on('error', function (event, type) {
					this.$el.attr('data-invalid', type);
					this.showError(type);
				}.bind(this))
				.on('valid', function () {
					this.$el.removeAttr('data-invalid');
					this.hideErrors();
				}.bind(this))
				.on('focus', this.onFocus.bind(this))
				.on('blur', this.onBlur.bind(this, this.input))
				.on('toggleResponsiveErrors', this._onToggleResponsiveErrors.bind(this));


			// есть два типа элементов - умные, которые сами эмитят события об ошибках -
			// error и valid
			// и обычные, которые сами себя не валидируют
			// и для обычных нужно обязательно скрывать ошибки на change
			if (this.input.smartValidation) {
				this.input.on('change', function(){
					this.onInputChange.call(this, this.input.getValue());
				}.bind(this));
			} else {
				this.input.on('change', function(){
					this.onInputChangeNoSmart.call(this);
				}.bind(this));
			}

			if (this.input.hasMod('correct-input-event')) {
				this.input.on('input', this.onCorrectInputChange.bind(this));
			} else {
				this.input.$el.on('input', this.onInputChangeNative.bind(this));
				this.input.$el.on('focus', this.onFocusInputNative.bind(this));
			}
		},

		/**
		 * если value true тогда нужно скрывать ошибки в поле, т.к. объект input
		 * сам будет показывать ошибки в состоянии респонсив
		 *
		 * @param event
		 * @param {boolean} value если true значит ошибки нужно скрыть
		 * @private
		 */
		_onToggleResponsiveErrors: function (event, value) {
			this.toggleMod('hidden-error-msg', value);
		},

		/**
		 * Ищет Input элемент и возвращает его, если их несколько то самый первый
		 *
		 * @private
		 */
		_findNativeInput: function () {
			var result = null;
			var inputs = this.$('input');

			if (inputs.length) {
				result = $(inputs[0]);
			}

			return result;
		},


		getValue: function () {
			var value;

			if (this.input) {
				if (typeof this.input.getValue === 'function') {
					value = this.input.getValue() || '';
				} else {
					value = this.input.$el.val();
				}

				// TODO хорошо бы удалить, но тогда сломается использование
				// b-dropdown в некоторых местах в бою, нужно искать
				// костыль, для обратной совместимости с b-dropdown, который возвращает объект
				if (
					typeof value === 'object' &&
					value.value != null &&
					!this.input.$el.hasClass('b-cellphone')
				) {
					value = value.value;
				}
			} else if (this.$nativeInput) {
				// TODO нужно удалить как все инпуты поддержат getValue
				if (this.$nativeInput.attr('type') === 'checkbox') {
					value = this.$nativeInput.prop('checked');
				} else {
					value = this.$nativeInput.val();
				}
			}

			return value;
		},

		setValue: function (val) {

			if (typeof this.input.setValue === 'function') {
				return this.input.setValue(val);
			} else {
				// TODO нужно удалить как все инпуты поддержат setValue
				return this.input.$el.val(val);
			}

		},

		/**
		 * Передаем модификатор дальше дочерним блокам
		 *
		 * @param mod
		 * @param state
		 */
		toggleMod: function (mod, state) {
			toolkit['b-toolkit'].fn.toggleMod.call(this, mod, state);

			if (mod === 'not-validated') {
				this.notValidated = state;
			}

			this.input.toggleMod(mod, state);

			if (mod === 'disabled') {

				if (!this._clickHandler) {
					this._clickHandler = function (event) {
						// отменяем преход по ссылке
						event.preventDefault();
						// отменяем переход через роутер
						event.stopPropagation();
					};
				}

				state = !!this.hasMod(mod);

				if (state) {
					this.$('a').on('tap', this._clickHandler);
				} else {
					this.$('a').off('tap', this._clickHandler);
				}
			}

		},

		/**
		 * Если метод вызовут асинхронно то могут перед этим вообще удалить форму
		 *
		 */
		focus: function () {
			if (this.$el) {
				this.$el.find('input, select, textarea').focus();
			}
		},

		/**
		 * Добавляет и показывает ошибку
		 *
		 * @param {string} type тип ошибки
		 * @param {number} index - индекс инпута, для полей с неколькими инпутами
		 * @param {string} text – кастомный текст ошибки, если необходимо
		 */
		showError: function (type, index, text) {

			if (this.hasMod('disabled')) {
				return;
			}

			if (!type) return;

			if (text === void 0 && isNaN(parseInt(index, 10))) {
				text = index;
				index = void 0;
			}

			// если собственная ошибка была найдена,
			// то все внешние валидаторы игнорируются
			if (this._ownError) {
				return;
			}

			if (this.error !== type || this.errorText !== text) {
				this.error = type;
				this.errorText = text;

				this.emit('updateErrors');

				var name = this.name || 'noname';

				this._debounceUiAbstractAction(name, this.error);

				// если элемент сам умеет показывать ошибки
				// тогда передаем ему эту обязанность, а сам филд не показывает ничего
				if (this.input && typeof this.input.showError === 'function') {
					this.input.showError(type, index, this.errorText);
				} else {
					this.$el.toggleMod('invalid', true);

					this.$('__errors').find('.js-error').toggleMod('visible', false);

					var error = this.$('__errors').find('.js-' + type);
					var errorText = this.errorText || error.data('text');

					error.toggleMod('visible', true);
					error.text(errorText);
				}
			}
		},

		/**
		 * Иногда ситуции когда сразу генериться сразу много одних и тех же ошибок
		 * иногда просто срабатывают события и input и change у инпутов в b-form-field
		 * и их обрабатывать нужно в реальном времени
		 *
		 * но радар можно задебаунсить
		 *
		 * @param {string} name
		 * @param {string} error
		 * @private
		 */
		_debounceUiAbstractAction: function (name, error) {
			name = name || '';
			error = error || '';

			if (!this._debounceHash) {
				this._debounceHash = {};
			}

			if (this._debounceHash[name + error]) {
				clearTimeout(this._debounceHash[name + error]);
			}

			this._debounceHash[name + error] = setTimeout(function () {
				$.event.trigger('ui-abstract-action', {
					chain: ['field-showerr', name, error]
				});
				this._debounceHash[name + error] = void 0;
			}.bind(this), 250);
		},

		/**
		 * Возвращает true если компонент обнаружил внутренними валидаторомами ошибку
		 *
		 * @returns {boolean}
		 */
		hasOwnError: function () {
			return !!this._ownError;
		},

		/**
		 * Скрывает ошибку
		 *
		 * @params {boolean} force если true то срываем все, даже внутреннюю ошибку
		 */
		hideErrors: function (force) {
			this.error = null;

			// если есть флаг что скрываем все, то удаляем флаг собственной ошибки
			if (force) {
				this._ownError = false;
			}
			// если собственная ошибка есть
			// то вызов этого публичного метода ничего не даст
			if (this._ownError) return;

			this.emit('updateErrors');

			// если элемент сам умеет удалять ошибки
			// тогда передаем ему эту обязанность, а сам филд не показывает ничего
			if (this.input && (typeof this.input.hideError === 'function')) {
				this.input.hideError();
			} else {
				this.$('__errors').find('.js-error').toggleMod('visible', false);
				this.$el.toggleMod('invalid', false);
			}

		},

		onFocus: function () {
			this.$el.toggleMod('focused', true);
		},

		onBlur: function (inputBlock) {
			this.$el.toggleMod('focused', false);

			this.emit('blurFormField');

			if (this.blurValidators) {
				if (inputBlock.previousValidateValue !== inputBlock.getValue()) {
					this.emit('needValidate');
					inputBlock.previousValidateValue = inputBlock.getValue();
				}
			}
		},

		/**
		 * Устанавливает функцию для получения всех данных внешней формы
		 *
		 * @param fn
		 */
		setGetterFormData: function (fn) {
			this._getFormData = fn;

			if (this.input && this.input.getParentData) {
				this.input.getParentData = fn;
			}
		},

		/**
		 * Обработчик для события input которое эмитится самим fildom
		 * а не его внутренними компонентами
		 *
		 * @param event
		 * @param value
		 */
		onCorrectInputChange: function () {
			// тут не скрываем ошибки
			// скрываем ошибки на событие valid

			this.emit('changeFormValue');
		},

		onInputChange: function () {
			this.emit('changeFormValue');
		},

		onInputChangeNative: function (evt) {
			// есть баг в ie11-, у input с placholder -  генерится эвент input,
			// когда мы просто фокусируемся на нем
			this.onInputChangeNoSmart(evt, $(evt.target).val());
		},

		onInputChangeNoSmart: function (evt, value) {
			if (value === void 0) {
				value = this.input.getValue();
			}

			if (this._previousValue !== value) {
				this.hideErrors();
				this.onInputChange();
				this._previousValue = value;
			}
		},

		onFocusInputNative: function (evt) {
			this._previousValue = $(evt.target).val();
		},

		validate: function (validator) {
			if (!this.input || typeof this.input.validate !== 'function') {
				return null;
			}

			return this.input.validate(validator);
		},

		/**
		 *
		 * @returns {boolean} true если поле находтся в статусе processing
		 */
		isProcessing: function () {
			if (this.input) {
				return this.input.hasMod('processing');
			}

			return false;
		},

		destroy: function () {
			if (this.input) {
				this.input
					.off('focus')
					.off('blur')
					.off('change');

			}

			toolkit['b-toolkit'].fn.destroy.apply(this, arguments);
		},

		/**
		 * Скрывает либо показывает сообщение
		 *
		 * @param {boolean} show если true - то показываем
		 * @param {string} msg если есть сообщение то меняем его
		 */
		toggleShowMessage: function (show, msg) {
			this.toggleMod('hide-message', !show);
			if (typeof msg === 'string') {
				var $msgElem = this.$('.b-form-field__message');
				$msgElem.text(msg);
			}
		},

		/**
		 * Возвращаем длину элемента
		 *
		 * @param $el
		 * @returns {Number}
		 */
		_getWidth: function ($el) {
			return parseInt($el.css('width'));
		},

		/**
		 * Отключаем анимация у ошибок для некоторых случаев
		 *
		 * @private
		 */
		_offErrorAnimate: function () {
			// MAIL-55100
			// отключаем у UC Browser мобильного т.к. там какая-то хрень с анимацией,
			// ошибки вообще не появляются
			if (
				(navigator.userAgent.includes('UCBrowser') &&
				navigator.userAgent.includes('Mobile Safari')) ||
				navigator.userAgent.includes('Windows Phone') ||
				// игнорируем все 4ки, т.к. в 4.3 и 4.4  была бага с тем что из-за
				// анимации вообще не показываются ошибки
				/Android\s4/i.test(navigator.userAgent) ||
				/iP[hone|od|ad]+AppleWebKit/i.test(navigator.userAgent)
			) {
				this.toggleMod('animate', false);
			}
		}
	});
});
